module.exports = __webpack_public_path__ + "img/20190807162539QQ截图20190807004028.bd232fc6.png";